const base = "https://helpdesk.com";
const integrations = `${base}/integrations`;

export const LandingPages = {
  OpenWidget: `${integrations}/openwidget`,
  LiveChat: `${integrations}/livechat`,
};
